// eslint-disable-next-line
function dataQualityAdapter(quality) {
  if (!quality) return null;
  if (quality) {
    return {
      qualityValue: quality.percentage_correctness,
      totalOnlinePostings: quality.allOnlinePostingCount,
      valueHigh: quality.qualitiesCount && quality.qualitiesCount.high_quality_count,
      valueMedium: quality.qualitiesCount && quality.qualitiesCount.medium_quality_count,
      valueLow: quality.qualitiesCount && quality.qualitiesCount.low_quality_count,
      valueNoData: quality.qualitiesCount && quality.qualitiesCount.no_data_count
    };
  }
}

export { dataQualityAdapter };
